var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5806 8.75033V8.33366C17.5806 5.19096 17.5806 3.61962 16.6044 2.6433C15.6281 1.66699 14.0567 1.66699 10.914 1.66699H10.0807C6.93809 1.66699 5.36675 1.66699 4.39045 2.64329C3.41414 3.61959 3.41412 5.19093 3.4141 8.3336L3.41406 12.0837C3.41404 14.8232 3.41403 16.193 4.17063 17.1149C4.30916 17.2837 4.46395 17.4385 4.63275 17.5771C5.5547 18.3337 6.92447 18.3337 9.66398 18.3337",
    stroke: "#1A234B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.83301H14.25",
    stroke: "#1A234B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10H11.75",
    stroke: "#1A234B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8317 11.668V12.6673C17.8317 13.9552 16.7877 14.9992 15.4998 14.9992M15.4998 14.9992C14.212 14.9992 13.168 13.9552 13.168 12.6673V11.668M15.4998 14.9992C16.7877 14.9992 17.8317 16.0432 17.8317 17.3311V18.3305M15.4998 14.9992C14.212 14.9992 13.168 16.0432 13.168 17.3311V18.3305",
    stroke: "#1A234B",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 11.668H18.1659M18.1659 18.3305H12.8359",
    stroke: "#1A234B",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAttachment);
export default __webpack_public_path__ + "static/media/document-attachment.a74138f46727843f9c852f04540cc2b0.svg";
export { ForwardRef as ReactComponent };